module.exports = __webpack_public_path__ + "img/home.7b2c9716.png";